import type { Translations } from '../../types'

const pagesMessages: Translations = {
  "pages.editor.slugLocked": "Slug bloccato: è l'indirizzo della homepage.",
  "pages.status.published": "Pubblicata",
  "pages.status.draft": "Bozza",
  "pages.toast.loadError": "Impossibile caricare le pagine ({{status}})",
  "pages.toast.loadErrorFallback": "Errore caricamento pagine",
  "pages.toast.deleteFailed": "Eliminazione fallita",
  "pages.toast.deleted": "Pagina spostata nel cestino.",
  "pages.toast.deleteError": "Errore eliminazione.",
  "pages.toast.restoreFailed": "Ripristino fallito",
  "pages.toast.restored": "Pagina ripristinata come bozza.",
  "pages.toast.restoreError": "Errore ripristino.",
  "pages.heading": "Pagine",
  "pages.eyebrow": "Contenuti",
  "pages.subheading": "Gestisci pagine contenuto, bozze, anteprime e metadati pagina.",
  "pages.create": "Nuova pagina",
  "pages.searchPlaceholder": "Cerca per titolo o slug...",
  "pages.filter.all": "Tutte",
  "pages.filter.published": "Pubblicate",
  "pages.filter.draft": "Bozze",
  "pages.filter.trash": "Cestino",
  "pages.results": "Risultati: {{total}} • Pagina {{pageNumber}} di {{totalPages}}",
  "pages.results.one": "1 pagina",
  "pages.results.many": "{{total}} pagine",
  "pages.itemLabel": "pagine",
  "pages.empty": "Nessuna pagina trovata",
  "pages.emptyDescription": "Crea una nuova pagina o modifica la ricerca.",
  "pages.trash.empty": "Cestino vuoto",
  "pages.trash.emptyDescription": "Le pagine eliminate appariranno qui e potranno essere ripristinate come bozze.",
  "pages.trash.note": "Le pagine nel cestino sono nascoste dallo storefront.",
  "pages.table.title": "Titolo",
  "pages.table.url": "URL",
  "pages.table.language": "Lingua",
  "pages.table.blocks": "Blocchi",
  "pages.table.status": "Stato",
  "pages.table.updated": "Aggiornato",
  "pages.table.deleted": "Eliminato",
  "pages.table.actions": "Azioni",
  "pages.status.trashed": "Cestino",
  "pages.row.publishedAt": "Pubblicata {{date}}",
  "pages.row.updatedAt": "Aggiornata {{date}}",
  "pages.row.deletedAt": "Eliminata {{date}}",
  "pages.row.noDescription": "Nessuna descrizione impostata.",
  "pages.meta.type": "Tipo",
  "pages.meta.locale": "Lingua",
  "pages.meta.updated": "Aggiornata",
  "pages.meta.published": "Pubblicata",
  "pages.meta.deleted": "Eliminata",
  "pages.type.homepage": "Homepage",
  "pages.type.system": "Pagina di sistema",
  "pages.type.standard": "Pagina standard",
  "pages.type.locked": "Bloccata",
  "pages.actions.edit": "Modifica",
  "pages.actions.preview": "Anteprima",
  "pages.actions.previewPage": "Anteprima {{title}}",
  "pages.actions.visit": "Visita",
  "pages.actions.more": "Altre azioni",
  "pages.actions.delete": "Sposta nel cestino",
  "pages.actions.deleteLocked": "Le pagine di sistema non possono essere spostate nel cestino",
  "pages.actions.restore": "Ripristina",
  "pages.actions.restoring": "Ripristino",
  "pages.pagination": "Pagina {{pageNumber}} di {{totalPages}}",
  "pages.prev": "Precedente",
  "pages.next": "Successiva",
  "pages.confirm.title": "Spostare questa pagina nel cestino?",
  "pages.confirm.body": "La pagina \"{{title}}\" diventerà bozza e sparirà dallo storefront. Potrai ripristinarla in seguito.",
  "pages.confirm.confirm": "Sposta nel cestino",
  "pages.confirm.cancel": "Annulla",
  "pages.form.title": "Pagine",
  "pages.form.heading": "Crea e modifica pagine CMS",
  "pages.form.description": "Le pagine possono essere poi collegate al menu di navigazione.",
  "pages.form.titleLabel": "Titolo pagina",
  "pages.form.slugLabel": "Slug",
  "pages.form.slugPlaceholder": "es. about, contatti",
  "pages.form.create": "Crea pagina",
  "pages.form.badge": "Pagina",
  "pages.form.customize": "Personalizza",
  "pages.form.empty": "Nessuna pagina ancora. Crea una pagina per iniziare.",
  "pages.toast.saved": "Pagina salvata.",
  "pages.editor.notFound": "Pagina non trovata",
  "pages.editor.loadError": "Errore caricamento pagina",
  "pages.editor.uploadAuth": "Autenticazione richiesta per caricare file",
  "pages.editor.uploadFailedStatus": "Upload fallito ({{status}})",
  "pages.editor.uploadInvalid": "Risposta upload non valida",
  "pages.editor.uploadError": "Errore upload",
  "pages.editor.requiredTitle": "Titolo obbligatorio",
  "pages.editor.requiredSlug": "Slug obbligatorio (senza \"/\")",
  "pages.editor.saveFailed": "Salvataggio fallito ({{status}}): {{message}}",
  "pages.editor.saveError": "Errore salvataggio pagina",
  "pages.editor.update": "Aggiorna",
  "pages.editor.publish": "Pubblica",
  "pages.editor.visit": "Visita",
  "pages.editor.backToList": "← Tutte le pagine",
  "pages.editor.saveDraft": "Salva bozza",
  "pages.editor.preview": "Anteprima",
  "pages.editor.titlePlaceholder": "Titolo pagina",
  "pages.editor.slugPlaceholder": "/slug",
  "pages.editor.metaTitle": "Meta title",
  "pages.editor.metaDescription": "Meta description",
  "pages.editor.excerpt": "Excerpt",
  "pages.editor.advanced": "Opzioni avanzate (SEO)",
  "pages.editor.advancedDescription": "Campi opzionali. Se non ti servono, puoi lasciarli vuoti.",
  "pages.editor.newPage": "Nuova pagina",
  "pages.editor.unsavedTitle": "Modifiche non salvate",
  "pages.editor.unsavedDescription": "Hai modifiche non salvate. Uscire senza salvare?",
  "pages.editor.unsavedConfirm": "Esci senza salvare",
  "pages.editor.unsavedCancel": "Continua a modificare",
  "pages.settings.identity": "Identità",
  "pages.settings.publishing": "Pubblicazione",
  "pages.settings.publicationMetadata": "Metadati pubblicazione",
  "pages.settings.managedBySave": "Gestiti da Pubblica e Salva",
  "pages.settings.advanced": "Avanzate",
  "pages.settings.futureOptions": "Le future opzioni a livello pagina appariranno qui.",
  "pages.translation.heading": "Traduzioni pagina",
  "pages.translation.description": "Gestisci le varianti lingua collegate a questa pagina.",
  "pages.translation.group": "Gruppo: {{groupId}}",
  "pages.translation.noPageYet": "Salva prima la pagina per creare o gestire traduzioni.",
  "pages.translation.currentLocale": "Lingua corrente",
  "pages.translation.currentStatus": "Stato traduzione",
  "pages.translation.status.draft": "Bozza",
  "pages.translation.status.inProgress": "In lavorazione",
  "pages.translation.status.published": "Pubblicata",
  "pages.translation.missingCurrentLocale": "Attenzione: manca la variante per la lingua corrente ({{locale}}).",
  "pages.translation.availableLanguages": "Lingue disponibili",
  "pages.translation.variants": "Varianti disponibili",
  "pages.translation.empty": "Nessuna variante collegata trovata.",
  "pages.translation.open": "Apri",
  "pages.translation.current": "Corrente",
  "pages.translation.createHeading": "Crea nuova variante",
  "pages.translation.createDescription": "Puoi partire dalla pagina corrente e clonare il contenuto.",
  "pages.translation.targetLocale": "Lingua target",
  "pages.translation.targetLocalePlaceholder": "Seleziona lingua",
  "pages.translation.titleOptional": "Titolo (opzionale)",
  "pages.translation.slugOptional": "Slug (opzionale)",
  "pages.translation.cloneContent": "Clona il contenuto della pagina sorgente",
  "pages.translation.create": "Crea traduzione",
  "pages.translation.createSuccess": "Traduzione creata.",
  "pages.translation.createError": "Errore creazione traduzione.",
  "pages.translation.loadError": "Errore caricamento traduzioni.",
  "pages.table.locale": "Lingua",
  "pages.table.translation": "Traduzione"
}

export default pagesMessages
